<template>
  <table class="table-sm" style="width: 100%; background: #95b4ff30">
    <thead>
      <tr>
        <th class="text-center border-gray" style="width: 28%; white-space: nowrap;">Campo</th>
        <th class="text-center border-gray" style="width: 36%; white-space: nowrap;">Valor antigo</th>
        <th class="text-center border-gray" style="width: 36%; white-space: nowrap;">Valor novo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in displayFields" :key="index">
        <td :title="auditData.id" class="border-gray">
          {{ getFieldLabel(item.field || index) }}
        </td>
        <td class="text-center border-gray">
          {{ getValue(item.oldValue, item.field || index) }}
        </td>
        <td class="text-center border-gray">
          {{ getValue(item.newValue, item.field || index) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { customerFieldsLabelMixin } from '@/mixins/customerFieldsLabelMixin';

export default {
  name: 'CustomerHistoryValuesTable',
  mixins: [customerFieldsLabelMixin],
  props: {
    auditData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getValue(value, field) {
      if (value === null || value === undefined) {
        return '-';
      }

      if (this.isDateField(field, value)) {
        return this.$options.filters ? this.$options.filters.date(value) : value;
      }

      if (field === 'status') {
        return this.getStatusLabel(value);
      }

      if (this.isBooleanField(field)) {
        return this.getBooleanLabel(value);
      }

      if (field === 'address' && typeof value === 'string') {
        return this.formatAddress(value);
      }

      if (this.isRelationshipField(field)) {
        return value;
      }

      return value || '-';
    },
    isDateField(field, value) {
      return ['start', 'automatic_finish_date'].includes(field) && value && value !== '0000-00-00';
    },
    getStatusLabel(value) {
      const statusMap = {
        '1': 'Ativo',
        '2': 'Cancelado',
        '3': 'Bloqueado',
        '4': 'Congelado',
        '5': 'Mudança de documento'
      };
      return statusMap[value.toString()] || value;
    },
    isBooleanField(field) {
      const booleanFields = [
        'ca_synchronized', 'block_manually', 'retention', 'deposit', 
        'is_automated', 'billing_new_app', 'is_invoice_automated'
      ];
      return booleanFields.includes(field);
    },
    getBooleanLabel(value) {
      if (value === true || value === 1 || value === '1') {
        return 'Sim';
      }
      if (value === false || value === 0 || value === '0') {
        return 'Não';
      }
      return value;
    },
    formatAddress(value) {
      try {
        const addresses = JSON.parse(value);
        if (Array.isArray(addresses) && addresses.length > 0) {
          const addr = addresses[0];
          return `${addr.logradouro || ''}, ${addr.numero || ''} - ${addr.bairro || ''}, ${addr.cidade || ''} - ${addr.uf || ''}, CEP: ${addr.cep || ''}`;
        }
      } catch (error) {
        console.warn('Erro ao fazer parse do endereço:', error);
        return value;
      }
      return value;
    },
    isRelationshipField(field) {
      const relationshipFields = [
        'segment_id', 'size_id', 'business_executive_id', 'customer_success_consultant_id'
      ];
      return relationshipFields.includes(field);
    },
  },
  computed: {
    displayFields() {
      if (!this.auditData || !this.auditData.audits) {
        return [];
      }

      const audits = this.auditData.audits;
      
      if (audits.some(audit => audit.new_values && audit.old_values)) {
        const fields = [];
        
        audits.forEach(audit => {
          if (audit.new_values && audit.old_values) {
            const newValues = audit.new_values;
            const oldValues = audit.old_values;
            
            const allFields = new Set([...Object.keys(newValues), ...Object.keys(oldValues)]);
            
            allFields.forEach(field => {
              fields.push({
                field: field,
                oldValue: oldValues[field],
                newValue: newValues[field]
              });
            });
          }
        });
        
        return fields;
      }
      
      // Formato 2: com field, from e to
      if (audits[0] && audits[0].field) {
        return this.auditData.audits.map(auditItem => ({
          field: auditItem.field,
          oldValue: auditItem.from,
          newValue: auditItem.to
        }));
      }
      
      return [];
    },
  },
};
</script>
